/* 
	TO BE DEPRECATED IN RELEASE 2.8
*/

import * as types from '../actiontypes';
import {createRequestURL} from '../../components/Common/CanvasForm/Bodies/Common/BodyResponseUtility';

export function getNoteDetail(url, gettingReplies, isGroupedByEngagement, payload, entityId) {
	return {
		type: types.GET_RNH_NOTE_DETAIL,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		},
		gettingReplies: gettingReplies,
		isGroupedByEngagement: isGroupedByEngagement,
		payload,
		entityId: entityId
	};
}

export function getNoteReplies(url, isGroupedByEngagement) {
	return {
		type: types.GET_RNH_NOTE_REPLIES,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		},
		isGroupedByEngagement: isGroupedByEngagement
	};
}

export function addNewNote(url, payload, noteInfo) {
	return {
		type: types.POST_RNH_NEW_NOTE,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: payload
			}
		},
		noteInfo: noteInfo
	};
}

export function replyToNote(url, body, payload) {
	return {
		type: types.POST_RNH_NOTE_REPLY,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: body
			}
		},
		...payload
	};
}

export function cleanSelectedNotes(useInitial) {
	return {
		type: types.CLEAR_RNH_NOTE_DETAIL,
		useInitial: useInitial
	};
}

export function openReviewNotesModal() {
	return {
		type: types.OPEN_RNH_NOTE_DETAIL_MODAL
	};
}

export function updateNoteDetailInfo(selectedNoteId, data) {
	return {
		type: types.UPDATE_RNH_NOTE_INFO,
		selectedNoteId: selectedNoteId,
		data: data
	};
}

export function updateNote(url, data, noteId, currentUser, sendCommentData = false, commentData = null) {
	return {
		type: types.UPDATE_RNH_NOTE_DETAIL,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: sendCommentData ? commentData : data
			}
		},
		data: data,
		noteId: noteId,
		currentUser: currentUser,
		sendCommentData: sendCommentData,
		commentData: commentData
	};
}

export function deleteNoteReply(url, data) {
	return {
		type: types.DELETE_RNH_NOTE_DETAIL,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		},
		data: data
	};
}

export function deleteParentNote(url, data) {
	return {
		type: types.DELETE_RNH_PARENT_NOTE,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		},
		data: data
	};
}

export function updateNotesCount(payload) {
	return {
		type: types.UPDATE_NOTES_COUNT,
		payload
	};
}

export function getFormBodyItem(engagementId, documentId, formBodyId) {
	const url = createRequestURL(engagementId, documentId, formBodyId);

	return {
		type: types.GET_FORM_BODY_COMMENT,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}
